import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    seatInfoTemplate: String,
    noPrices: String,
    updateFailed: String
  }

  async updateBasket(id, priceId) {
    const response = await fetch('/basket',
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': Rails.csrfToken(),
        },
        body: JSON.stringify({ "id": id, "price_id": priceId })
      }
    )

    if (response.status === 200 && response.headers.get('Content-Type')?.startsWith('text/vnd.turbo-stream.html')) {
      const body = await response.text()
      Turbo.renderStreamMessage(body)
    } else if (response.status === 403) {
      alert(this.updateFailedValue)
    }
  }

  showPriceModal(seatData) {
    const dialog = document.getElementById('priceModal')
    const seatInfo = document.getElementById('selectedSeatInfo')
    const priceOptions = document.getElementById('priceOptions')
    const selectedColor = getComputedStyle(document.documentElement).getPropertyValue('--seat-selected').trim()

    seatInfo.textContent = this.seatInfoTemplateValue
      .replace('%{row}', seatData.row)
      .replace('%{number}', seatData.number)

    // Clear and populate price options
    priceOptions.innerHTML = ''

    if (seatData.prices && seatData.prices.length > 0) {
      seatData.prices.forEach(price => {
        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'flex w-full items-center justify-between gap-4 px-4 py-3 text-left transition hover:bg-surface focus:bg-surface focus:outline-none'
        button.innerHTML = `
          <span class="text-sm font-medium text-slate-900">${price.name}</span>
          <span class="text-sm font-semibold text-ink">${price.currency.toUpperCase()} ${(price.cents / 100).toFixed(2)}</span>
        `
        button.addEventListener('click', () => {
          this.updateBasket(seatData.id, price.id)
          dialog.close()

          // Update seat visual to selected
          const circle = document.getElementById(`plan_event_seat_${seatData.id}`)
          if (circle) {
            circle.setAttribute("fill", selectedColor)
            circle.setAttribute("data-status", "selected") // Mark as selected to prevent Turbo Stream override
          }
        })
        priceOptions.appendChild(button)
      })
    } else {
      priceOptions.innerHTML = `<p class="px-4 py-3 text-sm text-slate-500">${this.noPricesValue}</p>`
    }

    dialog.showModal()
  }

  connect() {
    this.onSeatClick = (e) => this.showPriceModal(e.detail)
    this.onSeatDeselect = (e) => this.updateBasket(e.detail.id, null)
    this.onBeforeCache = () => document.getElementById('priceModal')?.close()

    document.addEventListener("seat-click-event", this.onSeatClick)
    document.addEventListener("seat-deselect-event", this.onSeatDeselect)
    document.addEventListener("turbo:before-cache", this.onBeforeCache)
  }

  disconnect() {
    document.removeEventListener("seat-click-event", this.onSeatClick)
    document.removeEventListener("seat-deselect-event", this.onSeatDeselect)
    document.removeEventListener("turbo:before-cache", this.onBeforeCache)
  }
}
